export class StyleCommand {
    public defaultButton = {'backgroundColor': ''};
    public eventButton = {'backgroundColor': ''};
    public placeButton = {'backgroundColor': ''};
    public pinnedEventBorder = {'borderColor': ''};
    public detailButton = {'backgroundColor': ''};
    public sidebarUnderline = {'color': ''};

    public tripPlanner = {
        event: {'color': '', isDefault: true},
        place: {'color': '', isDefault: true},
        tour: {'color': '', isDefault: true},
        trip: {'color': '', isDefault: true},
        buttons: {'color': '', isDefault: true},
    };
}

export class StyleModel {
    constructor() {
        this.defaultButton = {
            backgroundColor: {
                value: '#ccc',
                isDefault: true
            }
        };

        this.placeButton = {
            backgroundColor: {
                value: '#ccc',
                isDefault: true
            }
        };

        this.detailButton = {
            backgroundColor: {
                value: '#ccc',
                isDefault: true
            }
        };

        this.eventButton = {
            backgroundColor: {
                value: '#ccc',
                isDefault: true
            }
        };

        this.pinnedEventBorder = {
            borderColor: {
                value: '#ccc',
                isDefault: true
            }
        };

        this.sidebarUnderline = {
            color: {
                value: '#ccc',
                isDefault: true
            }
        };

        this.tripPlanner = {
            event: {
                color: {
                    value: '#3b6dac',
                    isDefault: true
                }
            },
            place: {
                color: {
                    value: '#23c6a0',
                    isDefault: true
                }
            },
            tour: {
                color: {
                    value: '#eec30d',
                    isDefault: true
                }
            },
            trip: {
                color: {
                    value: '#ff8834',
                    isDefault: true
                }
            },
            buttons: {
                color: {
                    value: '#41abf3',
                    isDefault: true
                }
            },
        };
    }

    public defaultButton: {
        backgroundColor: {
            value: string,
            isDefault: boolean
        }
    };
    public eventButton: {
        backgroundColor: {
            value: string,
            isDefault: boolean
        }
    };
    public placeButton: {
        backgroundColor: {
            value: string,
            isDefault: boolean
        }
    };
    public pinnedEventBorder: {
        borderColor: {
            value: string,
            isDefault: boolean
        }
    };
    public detailButton: {
        backgroundColor: {
            value: string,
            isDefault: boolean
        }
    };
    public sidebarUnderline: {
        color: {
            value: string,
            isDefault: boolean
        }
    };
    public tripPlanner: {
        event: {
            color: {
                value: string,
                isDefault: boolean
            }
        },
        place: {
            color: {
                value: string,
                isDefault: boolean
            }
        },
        tour: {
            color: {
                value: string,
                isDefault: boolean
            }
        },
        trip: {
            color: {
                value: string,
                isDefault: boolean
            }
        },
        buttons: {
            color: {
                value: string,
                isDefault: boolean
            }
        },
    };
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/hub/style.command.ts